module.exports = __webpack_public_path__ + "static/media/checkmark-settings_green.570ddd97.svg";